var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "container",
      staticClass: "grid-view",
      class: _vm.showRight ? "show-right" : "",
      attrs: { id: "config-manage" }
    },
    [
      _c(
        "div",
        { staticClass: "main-content left", staticStyle: { height: "100%" } },
        [
          _c("div", { staticClass: "app-main-inner-row" }, [
            _c(
              "div",
              { staticClass: "filters" },
              [
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary" },
                    on: {
                      click: function($event) {
                        return _vm.editConfigItem()
                      }
                    }
                  },
                  [
                    _vm._v(
                      _vm._s(_vm.$t("CargoMsg.Cargo_EditConfigurationItem"))
                    )
                  ]
                ),
                _c(
                  "span",
                  {
                    staticClass: "box-label",
                    staticStyle: { "margin-left": "10px" }
                  },
                  [
                    _vm._v(
                      _vm._s(
                        _vm.$t("CargoMsg.Cargo_EditConfigurationDefinition")
                      )
                    )
                  ]
                )
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "triggers" },
              [
                _c("span", [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Search")))]),
                _c("el-input", {
                  staticStyle: { width: "200px", margin: "0 10px" },
                  attrs: {
                    placeholder: _vm.$t(
                      "SystemMaintenance.PleaseConfigurationNameOrRemarks"
                    )
                  },
                  on: {
                    input: function($event) {
                      _vm.filter.pageNum = 1
                      _vm.toQuery()
                    }
                  },
                  model: {
                    value: _vm.filter.likeName,
                    callback: function($$v) {
                      _vm.$set(_vm.filter, "likeName", $$v)
                    },
                    expression: "filter.likeName"
                  }
                }),
                this.$store.getters.tenantId === 1
                  ? _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: {
                          click: function($event) {
                            return _vm.showEditDialog(true)
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("common.btn.new")))]
                    )
                  : _vm._e(),
                this.$store.getters.tenantId === 1
                  ? _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: {
                          click: function($event) {
                            return _vm.showEditDialog(false)
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("common.btn.edit")))]
                    )
                  : _vm._e(),
                this.$store.getters.tenantId === 1
                  ? _c(
                      "el-button",
                      {
                        attrs: { size: "mini", type: "danger" },
                        on: { click: _vm.remove }
                      },
                      [_vm._v(_vm._s(_vm.$t("common.btn.delete")))]
                    )
                  : _vm._e(),
                _c(
                  "el-button",
                  {
                    attrs: { size: "mini", type: "primary" },
                    on: {
                      click: function($event) {
                        _vm.filter.pageNum = 1
                        _vm.toQuery()
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("common.btn.refresh")))]
                )
              ],
              1
            )
          ]),
          _c(
            "div",
            {
              staticClass: "section grid-wrapper",
              staticStyle: { height: "90%" }
            },
            [
              _c("cargo-ag-grid", {
                attrs: {
                  "config-module": "200102",
                  "grid-params": _vm.girdParams,
                  "grid-options": _vm.gridOptions,
                  "column-defs": _vm.columnDefs,
                  "row-data": _vm.rowData
                },
                on: {
                  "update:gridParams": function($event) {
                    _vm.girdParams = $event
                  },
                  "update:grid-params": function($event) {
                    _vm.girdParams = $event
                  }
                }
              })
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "pagination-wrapper" },
            [
              _c("cargo-pagination", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.total > 0,
                    expression: "total>0"
                  }
                ],
                attrs: {
                  "config-module": "2001021",
                  total: _vm.total,
                  page: _vm.filterJson.pageNum,
                  limit: _vm.filterJson.pageSize
                },
                on: {
                  "update:page": function($event) {
                    return _vm.$set(_vm.filterJson, "pageNum", $event)
                  },
                  "update:limit": function($event) {
                    return _vm.$set(_vm.filterJson, "pageSize", $event)
                  },
                  pagination: function($event) {
                    return _vm.toQuery()
                  }
                }
              })
            ],
            1
          )
        ]
      ),
      _c("div", { staticClass: "division" }),
      _c("configuration-management-sub", {
        staticClass: "right",
        staticStyle: { height: "100%" },
        attrs: { "config-id": _vm.configId, "config-name": _vm.configName }
      }),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            visible: _vm.editDialog.visible,
            title: _vm.editDialog.title,
            width: "500px",
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.editDialog, "visible", $event)
            }
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "app-main-inner-row",
              staticStyle: { "padding-bottom": "10px" }
            },
            [
              _c(
                "el-form",
                { attrs: { "label-width": "90px", "label-position": "left" } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SystemMaintenance.Type") } },
                    [
                      _c("el-input", {
                        model: {
                          value: _vm.editDialog.form.dataType,
                          callback: function($$v) {
                            _vm.$set(_vm.editDialog.form, "dataType", $$v)
                          },
                          expression: "editDialog.form.dataType"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("SystemMaintenance.InterfaceSettings")
                      }
                    },
                    [
                      _c(
                        "el-radio-group",
                        {
                          model: {
                            value: _vm.editDialog.form.client,
                            callback: function($$v) {
                              _vm.$set(_vm.editDialog.form, "client", $$v)
                            },
                            expression: "editDialog.form.client"
                          }
                        },
                        [
                          _c("el-radio", { attrs: { label: true } }, [
                            _vm._v(_vm._s(_vm.$t("SystemMaintenance.Yes")))
                          ]),
                          _c("el-radio", { attrs: { label: false } }, [
                            _vm._v(_vm._s(_vm.$t("SystemMaintenance.No")))
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "分公司选项" } },
                    [
                      _c(
                        "el-radio-group",
                        {
                          model: {
                            value: _vm.editDialog.form.officeOption,
                            callback: function($$v) {
                              _vm.$set(_vm.editDialog.form, "officeOption", $$v)
                            },
                            expression: "editDialog.form.officeOption"
                          }
                        },
                        [
                          _c("el-radio", { attrs: { label: true } }, [
                            _vm._v(_vm._s(_vm.$t("SystemMaintenance.Yes")))
                          ]),
                          _c("el-radio", { attrs: { label: false } }, [
                            _vm._v(_vm._s(_vm.$t("SystemMaintenance.No")))
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "服务设置" } },
                    [
                      _c(
                        "el-radio-group",
                        {
                          model: {
                            value: _vm.editDialog.form.server,
                            callback: function($$v) {
                              _vm.$set(_vm.editDialog.form, "server", $$v)
                            },
                            expression: "editDialog.form.server"
                          }
                        },
                        [
                          _c("el-radio", { attrs: { label: true } }, [
                            _vm._v(_vm._s(_vm.$t("SystemMaintenance.Yes")))
                          ]),
                          _c("el-radio", { attrs: { label: false } }, [
                            _vm._v(_vm._s(_vm.$t("SystemMaintenance.No")))
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "可选项" } },
                    [
                      _c("el-input", {
                        model: {
                          value: _vm.editDialog.form.literals,
                          callback: function($$v) {
                            _vm.$set(_vm.editDialog.form, "literals", $$v)
                          },
                          expression: "editDialog.form.literals"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("SystemMaintenance.ConfigurationName")
                      }
                    },
                    [
                      _c("el-input", {
                        model: {
                          value: _vm.editDialog.form.name,
                          callback: function($$v) {
                            _vm.$set(_vm.editDialog.form, "name", $$v)
                          },
                          expression: "editDialog.form.name"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SystemMaintenance.Remark") } },
                    [
                      _c("el-input", {
                        model: {
                          value: _vm.editDialog.form.remarks,
                          callback: function($$v) {
                            _vm.$set(_vm.editDialog.form, "remarks", $$v)
                          },
                          expression: "editDialog.form.remarks"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: _vm.$t("SystemMaintenance.DefaultValue") }
                    },
                    [
                      _c("el-input", {
                        model: {
                          value: _vm.editDialog.form.value,
                          callback: function($$v) {
                            _vm.$set(_vm.editDialog.form, "value", $$v)
                          },
                          expression: "editDialog.form.value"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.save } },
                [_vm._v(_vm._s(_vm.$t("common.btn.save")))]
              ),
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.editDialog.visible = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }